// extracted by mini-css-extract-plugin
export const header = "header-module--header--_rwsu";
export const title = "header-module--title--2VjU5";
export const navList = "header-module--nav-list--1BtLb";
export const navLink = "header-module--nav-link--1ZWsl";
export const activeNavLink = "header-module--active-nav-link--2DDLi";